import React from 'react';
import accounting from "accounting";
import Chips from "../components/Club/ChipBalance/Chips";
const currencySymbols = {
  'USD': '$',
  'EUR': '€',
  'TRY': '₺',
  'TND': 'DT',
};

export const getCurrencySymbol = currency => currencySymbols[currency] || '';

export const formatCurrency = (amount, lang, currency) => {
  if( currency === 'FPP' && !!amount ) {
    return (<Chips val={amount} />);
  }
  return accounting.formatMoney(amount, getCurrencySymbol(currency) + ' ');
}

export const formatToOrdinal = number => {
  const lim = number % 10;
  if ((number > 3 && number < 20) || lim > 3) return `${number}th`;
  if (lim === 3) return `${number}rd`;
  if (lim === 2) return `${number}nd`;
  if (lim === 1) return `${number}st`;
  return `${number}th`;
}